import { render, staticRenderFns } from "./serveStation.vue?vue&type=template&id=17a92a4d&scoped=true&"
import script from "./serveStation.vue?vue&type=script&lang=js&"
export * from "./serveStation.vue?vue&type=script&lang=js&"
import style0 from "./serveStation.vue?vue&type=style&index=0&id=17a92a4d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a92a4d",
  null
  
)

export default component.exports